module.exports = __webpack_public_path__ + "static/dots-43b130349051b539a5d79d3d44b79230.svg";